<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header py-0">
          <a-row
            class='py-2'
          >
            <a-col
              :sm='24'
              :lg='20'
              class='pr-1'
            >
              <a-input
                style="width: 100%"
                placeholder="Buscar..."
                @keyup.enter="getConsignmentNotes(10, 0, searchText)"
                v-model:value="searchText"
              />
            </a-col>
            <a-col
              :sm='24'
              :lg='4'
              class='pl-1'
            >
              <button
                class="btn bg-holcim-bright-green text-white"
                @click="getConsignmentNotes(10, 0, searchText)"
                style="width: 100%"
              >
                <i class="fe fe-refresh-cw" />
                Buscar
              </button>
            </a-col>
          </a-row>
        </div>
        <div class="card-body">
          <main-table
            :data="consignmentNotes"
            :loading="tableLoading"
          />
          <a-pagination
            class="pt-4"
            v-model="paginatorCurrentPage"
            :total="paginatorTotalItems"
            @change="onChangePaginator"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useConsignmentNote from "../../composables/useConsignmentNote";
import MainTable from "../main/components/mainTable";

export default {
  name: 'HistorialMain',
  components: {MainTable},
  setup() {

    const {
      searchText,
      formId,
      consignmentNotes,
      tableLoading,

      paginatorTotalItems,
      paginatorTotalPages,
      paginatorCurrentPage,
      onChangePaginator,

      getConsignmentNotes,
    } = useConsignmentNote()

    return {
      searchText,
      formId,
      consignmentNotes,
      tableLoading,

      paginatorTotalItems,
      paginatorTotalPages,
      paginatorCurrentPage,
      onChangePaginator,

      getConsignmentNotes,
    }

  },
}

</script>

<style scoped>

</style>
